import CustomDatatableReports from '../../libs/datatables/custom_datatable_reports'

export default function () {
  window.addEventListener('load', () => {
    new CustomDatatableReports($('table.report'))
  })
}
